export const migrations = {
  Wellevate: {
    Banners: {
      SuccessMessage: "Banner dismissed successfully!",
      ErrorMessage: "Error while dismissing the banner.",
      PatientList: {
        Title: "Looking for your Wellevate {{patientTermPlural}}?",
        Subtitle1:
          "Look for this <1/> ! It's here to help you quickly identify {{patientTermPlural}} that were created in Wellevate.",
        Subtitle2:
          "You can also find {{patientTermPlural}} created in Wellevate by clicking Filters and then selecting the Created filter.",
        Subtitle2Alt:
          'You can also find {{patientTermPlural}} created in Wellevate by clicking Patient Status and then selecting the "in Wellevate" filter.',
      },
      Favorites: {
        Title: "Want more control over how your {{ patientTermPlural }} see your catalog?",
        Subtitle: "Review your settings in <1>catalog permissions.</1>",
      },
      Protocols: {
        Title: "Looking for your Wellevate data?",
        Subtitle:
          "Look for this <1/> ! It's here to help you quickly identify protocols that originated in Wellevate.",
        MissingProducts: {
          Title: "Missing products",
          Subtitle:
            "If you notice one or more of the products missing from your Wellevate protocols, don't be alarmed. It just means they are not available in the Fullscript catalog, but there are plenty of great alternative products to be found in Fullscript's vast catalog. Go check it out!",
          Button: "Search Catalog",
        },
      },
      Importer: {
        Callout: "Time sensitive",
        Header: "Migrate your Wellevate info",
        Body: "Make Fullscript your new home by migrating your {{ patientTermPlural }}, protocols, and favorite products. In doing so, {{ patientTermPlural }} will receive their {{ treatmentPlanTermPlural }} and order history, too! <7>It only takes 5 minutes.</7>",
        CTA: "Start migration",
        SubCTA: "Learn more",
        InProgress: {
          Header: "Import in progress",
          Body: "We're currently working to seamlessly import your Wellevate account information into your Fullscript account.",
          Note1: "Feel free to continue using your account while you wait.",
          Note2: "You'll be notified via email when the information import is complete.",
          CTA: "View import page",
        },
      },
    },
    Protocols: {
      Source: "Imported from: Wellevate",
      ReviewRequired: "Review required:",
      ProductAvailabilityIssue: "Product availability issue",
      ProtocolDetailsPage: {
        Banner: {
          header: "A product was removed from this protocol",
          header_plural: "Products were removed from this protocol",
          subheader: "{{totalUnavailableProducts}} product added in Wellevate is unavailable:",
          subheader_plural:
            "{{totalUnavailableProducts}} products added in Wellevate are unavailable:",
          Dismiss: "Dismiss",
        },
        Modal: {
          Header: "Dismiss removed products?",
          Body: "The product(s) removed from this protocol will not be available to reference once dismissed.",
          Back: "Cancel",
          CTA: "Yes, dismiss",
        },
      },
    },
    Modals: {
      Importer: {
        Header: "Important information before starting",
        AccountInformation: {
          Header: "We ensure a seamless and secure transfer of your information",
          ListItem1:
            "Your {{patientTermPlural}}, their order and {{treatmentPlanTerm}} history, your protocols, and favorites will be imported from Wellevate to Fullscript.",
        },
        OnFullscript: {
          Header: "Everything you need will be on Fullscript",
          ListItem1: "After migrating to Fullscript, your Wellevate account will become read-only.",
          ListItem2: "Fullscript will become your all-in-one place for virtual dispensing.",
        },
        Informed: {
          Header: "It'll be a smooth process for your {{patientTermPlural}}",
          ListItem1:
            "Once you complete the migration, your {{patientTermPlural}} will be guided through a similar account sync that will include their {{treatmentPlanTermPlural}} and order history to ensure continuity of care.",
          ListItem2:
            "All {{patientTermPlural}} associated with your Wellevate account will get clear instructions on how to use Fullscript to meet their needs.",
        },
        SubPractitioners: {
          Header: "Sub-practitioners are able to join, too",
          ListItem1:
            "Any Wellevate practitioners associated with your practice can be added to your Fullscript account as sub-practitioners.",
        },
        Footer: "If you have any questions, <2>visit our support center</2>",
        Cancel: "Cancel",
        CTA: "Start migration",
      },
    },
    DataImport: {
      MenuOptionLabel: "Start Wellevate migration",
      MenuOptionInProgressLabel: "Wellevate migration",
      MenuOptionSummaryLabel: "Wellevate migration summary",
    },
    ImportStepper: {
      Title: "Migrate your Wellevate account in 4 simple steps",
      Steps: {
        GetInformed: "Get informed",
        SignIn: "Sign in",
        ImportInfo: "Import info",
        Enjoy: "Enjoy",
      },
    },
    ImportContents: {
      ContactInfo: "If you have any questions, <1>visit our support center</1>",
      Button: {
        Continue: "Continue",
      },
      GetInformed: {
        Title: "Some information you should know before starting",
        Subtitle1: "We ensure a seamless and secure transfer of your information",
        Point1:
          "Your {{ patientTermPlural }}, their order and {{ treatmentPlanTerm }} history, your protocols, and favorites will be imported from Wellevate to Fullscript.",
        Subtitle2: "Everything you need will be on Fullscript",
        Point2: "After migrating to Fullscript, your Wellevate account will become read-only.",
        Point3: "Fullscript will become your all-in-one place for virtual dispensing.",
        Subtitle3: "It'll be a smooth process for your {{ patientTermPlural }}",
        Point4:
          "Once you complete the migration, your {{ patientTermPlural }} will be guided through a similar account sync that will include their {{treatmentPlanTermPlural}} and order history to ensure continuity of care.",
        Point5:
          "All {{ patientTermPlural }} associated with your Wellevate account will get clear instructions on how to use Fullscript to meet their needs.",
        Subtitle4: "Sub-practitioners are able to join, too",
        Point6:
          "Any Wellevate practitioners associated with your practice can be added to your Fullscript account as sub-practitioners.",
      },
      SignIn: {
        Title: "Sync your Wellevate and Fullscript accounts",
        Subtitle: "For security reasons, please sign in using your Wellevate credentials.",
        Email: "Enter Wellevate email",
        Password: "Enter Wellevate password",
        ContactCustomerService: "Contact Customer Success to reset your password",
        IncorrectEmailOrPassword: "Incorrect email or password. Please try again.",
      },
      LoyalistInitiated: {
        Header: "Migrate your Wellevate account",
        Subheader: "You're 1 click away, and it takes less than 5 minutes.",
        Info1: {
          Title: "Seamless and secure",
          Subtitle: "Get back to business disruption-free by importing:",
          Point1: "{{ patientTermCapitalized }} lists",
          Point2: "Protocols",
          Point3: "Favorites",
        },
        Info2: {
          Title: "Continuity of care",
          Subtitle: "We'll equip your patients with the tools and information they need:",
          Point1: "Clear and guided steps to get started",
          Point2: "Wellevate order history",
          Point3: "Wellevate {{ treatmentPlanTerm }} history",
        },
        Info3: {
          Title: "Fullscript is the new Wellevate",
          Subtitle: "Find everything you need for virtual dispensing on Fullscript:",
          Point1: "Catalog of 20,000+ products",
          Point2: "{{ treatmentPlanTermCapitalized }} adherence support",
          Point3: "Integrate with your EHR",
        },
        Footer: {
          Message1: "Your Wellevate account will become read-only when the migration is complete.",
          Message2: "Individual {{ patientTerm }} discounts and lab results will not be imported.",
          Button: {
            Label: "Start migration",
          },
        },
      },
      InProgress: {
        Title: "Import in progress",
        Subtitle: "Next steps for your {{ patientTermPlural }}",
        Content1:
          "We're currently working to seamlessly import your Wellevate account information into your Fullscript account.",
        Content2:
          "After import is complete we'll email your {{ patientTermPlural }} to help them get set up on Fullscript, with all of their Wellevate history available as soon as they arrive.",
        Content3:
          "You can find a full set of resources in the <1>practitioner migration toolkit</1>.",
        Point1: "You can leave this page at any time.",
        Point2: "This process should take less than 5 minutes to complete.",
        Point3: "You'll be notified via email when the import is complete.",
        Video: {
          Title: "How to move your Wellevate account to Fullscript | Patient support",
          Subtitle: "{{ patientTermSingularCapitalize }} migration overview • 3 mins",
          Content:
            "Watch a walkthrough of how your {{ patientTermPlural }} will move to Fullscript.",
        },
      },
      Failed: {
        Title: "Your import is taking longer than usual.",
        Subtitle: "If you feel there has been an error, <1>contact support.</1>",
      },
      Report: {
        Title: "Your Wellevate account migration is complete",
        Patients:
          "<0>{{patientTerm}}</0> {{patientTermGrammar}} been added to your <5>{{patientTermSingularCapitalize}} list</5>.",
        PatientCell: {
          Title: "We've emailed your {{ patientTermPlural }} with info on moving to Fullscript.",
          Point:
            "If an existing {{ patientTermSingular }} signs into Fullscript, they'll be prompted to migrate their Wellevate account into their Fullscript account.",
        },
        Orders:
          "<0>{{orderTerm}}</0> {{orderGrammar}} been added to your <5>{{patientTermSingularCapitalize}} order history page</5>.",
        TreatmentPlans: "<0>{{treatmentPlanTerm}}</0> {{treatmentPlanGrammar}} been added.",
        Protocols:
          "<0>{{protocolTerm}}</0> {{protocolGrammar}} been added to your <4>Protocols page</4>.",
        FavoriteProducts:
          "<0>{{favoritedProductTerm}}</0> {{favoritedProductGrammar}} been added to <5>your Favorites</5>.",
        FavoriteProductsNote:
          "Note: products with multiple sizes are combined into a single favourite.",
        None: "<0>items</0> have been added to your Fullscript account since there was no items in your Wellevate account to move.",
        CTA: "Continue",
        Errors: {
          Protocol: {
            unimported: "{{ count }} protocol could not be imported.",
            unimported_plural: "{{ count }} protocols could not be imported.",
            importedwitherror: "{{ count }} imported protocol includes unavailable products.",
            importedwitherror_plural:
              "{{ count }} imported protocols include unavailable products.",
          },
          Patient: {
            Content: "{{ patientErrorCount }} {{ patientTerm }} could not be imported.",
          },
        },
      },
    },
    Loyalist: {
      MarginBanner: {
        Title: "Wellevate profit margin: {{ wellevateLoyalistProfitMargin }}%",
        Description:
          "Maintain a consistent experience for your {{ patientTermPlural }} by matching your Wellevate store's margin to the nearest 5% increment.",
      },
      WellevateStepWrapper: {
        Header: "Welcome to Fullscript, {{ pracName }}",
        Title: "Match your Wellevate profit margin",
        TitleWithMargin: "Match your {{ wellevateLoyalistProfitMargin }}% Wellevate profit margin",
        Description:
          "Earn up to a {{ maxValue }}% margin from {{ patientTerm }} orders or pass along your profit as discounts to {{ patientTermPlural }} on their orders.",
        SubTitle: "How it works",
        ExampleProfit: "Example profit: <1>{{ selectedMargin }}%</1>",
        PatientDiscount: "Discount: <1>{{ patientDiscount }}%</1>",
        SkipButton: "Skip for now",
        ProfitButton: "Set up profit account",
      },
      OnboardingChecklist: {
        Title: "Complete migrating to Fullscript",
        NotNow: "Not right now",
        SetupProfitAccount: {
          Title: "Match your Wellevate profit margin",
          TitleWithMargin:
            "Match your {{ wellevateLoyalistProfitMargin }}% Wellevate profit margin",
          Description:
            "Keep your store margin and {{patientTerm}} discounts consistent by setting up a profit account. You can do this at anytime in your dispensary settings.",
          Cta: "Set up profit account",
        },
        SetCatalogPermissions: {
          Title: "Customize your {{patientTerm}}' catalog experience",
          Description:
            "Choose how you want your {{patientTerm}} to experience Fullscript – whether it's the ability to browse over 20,000 products, accessing your favorites, or sticking with your {{treatmentPlanTerm}}.",
          Cta: "Set catalog permissions",
        },
        MigrateYourWellevateInfo: {
          Title: "You're ready to migrate from Wellevate to Fullscript!",
          Body: "Follow the banner above to Migrate your Wellevate account or learn more through the video below",
        },
      },
      Credentials: {
        Message: {
          Title: "Skip the wait — your credentials are pre-approved!",
          Body: "Rest assured, our thorough screening process ensures all healthcare providers meet Fullscript and Wellevate's professional standards. Enjoy access to our platform for you and your {{patientTermPlural}} without delays.",
        },
        Footer: {
          Footnote: "How we protect your information",
          Tooltip:
            "Fullscript is committed to protecting your privacy. All information provided is securely encrypted.",
          Later: "I'll do this later",
          CTA: "Next: Select account type",
        },
        Title: "Add phone number and state",
        State: "State",
        PhoneNumberLabel: "Preferred phone number",
      },
      StripeBanner: {
        Title: "Fullscript handles Stripe for you",
        Content:
          "When setting up for payouts, Fullscript sets up a Stripe account in the background on your behalf. No further action is needed. Fullscript also generates your annual tax documentation for you.",
      },
      CatalogPermissions: {
        Message: {
          title: "One last step to finish migration",
          content:
            "Make Fullscript your new home by migrating your {{patientTermPlural}}, protocols, and favorite products. In doing so, patients will receive their {{treatmentPlanTermPlural}} and order history too. <5>It only takes 5 minutes.</5>",
          CTA: "Start migration",
          SubCTA: "Learn more",
        },
      },
      Toast: {
        Confirmation: "Are you migrating from Wellevate?",
        Yes: "Yes",
        Dismiss: "Dismiss",
      },
    },
  },
  Filters: {
    InFullscript: "In Fullscript",
    InWellevate: "In Wellevate",
  },
  Rupa: {
    StatusBox: {
      ImportingData: "Importing your Rupa data...",
      ImportComplete: "Import complete!",
      LoadingStatus: "Loading migration status...",
      Labels: {
        Patients: "patients",
        LabOrders: "lab orders",
        Bundles: "bundles (templates)",
        Snippets: "text snippets",
        Favorites: "favorites",
        Panels: "blood panels",
      },
      Buttons: {
        LearnMore: "Learn more about the move",
        BookCall: "Book a call",
      },
      VideoTitle: "Dr. Gladd explaining Journeys",
      ErrorMessage:
        "We ran into an error while importing some of your data, but don't worry! We are actively looking into it and will reach out to you shortly.",
    },
  },
} as const;
